export default {
  'pages.workbench.defaultUser': '夥伴',
  'pages.workbench.enterpriseWorkspace': '企業工作空間',
  'pages.workbench.welcome': '歡迎回來，{name}',
  'pages.workbench.welcomeDescription':
    '連接應用、基礎服務與維運，從這裡開始今天的工作。',
  'pages.workbench.refresh': '重新整理工作臺',
  'pages.workbench.openAppCenter': '進入應用',
  'pages.workbench.partialError': '部分資料暫時無法載入，已顯示可用內容。',
  'pages.workbench.retry': '重新載入',
  'pages.workbench.overview': '工作空間概覽',
  'pages.workbench.installedApps': '已開通應用',
  'pages.workbench.availableToTeam': '企業已開通的業務應用',
  'pages.workbench.myApps': '我的應用',
  'pages.workbench.myAppsDescription': '企業已開通的應用，隨時開始工作',
  'pages.workbench.viewAll': '查看全部',
  'pages.workbench.enabled': '已開通',
  'pages.workbench.openApp': '開啟 {name}（新視窗）',
  'pages.workbench.viewApp': '查看 {name}',
  'pages.workbench.noApps': '開通你的第一個企業應用',
  'pages.workbench.noAppsDescription':
    '從應用市場探索適合團隊的工具，讓業務協作更簡單。',
  'pages.workbench.appsError': '應用清單暫時無法使用',
  'pages.workbench.retryDescription': '請重新載入，或進入對應中心查看。',
  'pages.workbench.browseMarket': '瀏覽應用市場',
  'pages.workbench.resourceOverview': '資源概覽',
  'pages.workbench.resourceOverviewDescription': '目前工作空間的叢集資源用量',
  'pages.workbench.cpu': 'CPU',
  'pages.workbench.memory': '記憶體',
  'pages.workbench.cores': '核心',
  'pages.workbench.gib': 'GiB',
  'pages.workbench.notConnected': '尚未連接',
  'pages.workbench.unavailable': '暫無資料',
  'pages.workbench.resourceUsage': '已使用 {used} / {total} {unit}',
  'pages.workbench.connectClusterDescription': '連接企業叢集後查看資源用量',
  'pages.workbench.openMonitoring': '查看資源監控',
  'pages.workbench.guideTitle': '開始探索更多可能',
  'pages.workbench.guideDescription': '為團隊找到合適的應用與能力。',
  'pages.workbench.guide.apps': '探索業務應用',
  'pages.workbench.guide.appsDescription': '瀏覽企業應用，擴充團隊工具',
  'pages.workbench.footer': '企業數位智慧化作業系統',
  'pages.workbench.deployments': '我的部署',
  'pages.workbench.deploymentsInCluster': '執行在企業叢集中的服務',
  'pages.workbench.clusterNodes': '叢集節點',
  'pages.workbench.readyNodes': '已就緒的節點',
  'pages.workbench.runningPods': '執行中容器組',
  'pages.workbench.podsInCluster': '叢集內正在執行的 Pod',
  'pages.workbench.deploymentsPanel': '我的部署',
  'pages.workbench.deploymentsPanelDescription': '已部署到企業叢集的應用與服務',
  'pages.workbench.allDeployments': '全部部署',
  'pages.workbench.noDeployments': '尚未有任何部署',
  'pages.workbench.noDeploymentsDescription':
    '從部署範本一鍵部署或建立自訂映像檔部署。',
  'pages.workbench.deploymentsError': '部署清單暫時無法使用',
  'pages.workbench.openAppStore': '前往部署範本',
  'pages.workbench.guide.appStore': '部署雲原生應用',
  'pages.workbench.guide.appStoreDescription':
    '一鍵部署資料庫、維運面板與自訂容器',
};
